import {
  DollarSign,
  Target,
  Users,
  Lightbulb,
  Laptop,
  Heart,
  Award,
  TrendingUp,
  Scale,
  ArrowRight
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

interface Step3Props {
  data: {
    priorities: string[];
  };
  onUpdate: (data: any) => void;
  onNext: () => void;
  onBack: () => void;
}

const priorityOptions = [
  { id: "splits", label: "High commission splits", icon: DollarSign },
  { id: "mentorship", label: "Strong mentorship", icon: Users },
  { id: "leads", label: "Quality leads", icon: Target },
  { id: "tech", label: "Tech & tools", icon: Laptop },
  { id: "culture", label: "Team culture", icon: Heart },
  { id: "brand", label: "Brand recognition", icon: Award },
  { id: "growth", label: "Growth opportunities", icon: TrendingUp },
  { id: "balance", label: "Work-life balance", icon: Scale },
];

const OnboardingStep3 = ({ data, onUpdate, onNext, onBack }: Step3Props) => {
  const togglePriority = (id: string) => {
    const current = data.priorities;
    const updated = current.includes(id)
      ? current.filter((p) => p !== id)
      : [...current, id];
    onUpdate({ ...data, priorities: updated });
  };

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-bold text-foreground">What are you looking for?</h2>
        <p className="text-muted-foreground">Tell us what matters so we can prioritize the right teams</p>
      </div>

      <div className="space-y-6">
        {/* Priorities */}
        <div className="space-y-3">
          <Label className="flex items-center gap-2">
            <Lightbulb className="h-4 w-4 text-primary" />
            What matters most to you?
          </Label>
          <p className="text-xs text-muted-foreground">Select all that apply</p>
          <div className="grid grid-cols-2 gap-2">
            {priorityOptions.map((option) => {
              const isSelected = data.priorities.includes(option.id);
              return (
                <button
                  key={option.id}
                  onClick={() => togglePriority(option.id)}
                  className={`flex items-center gap-3 p-3 rounded-xl border transition-all ${
                    isSelected
                      ? "border-primary bg-primary/10 text-foreground"
                      : "border-border bg-background hover:bg-muted text-muted-foreground"
                  }`}
                >
                  <div className={`p-2 rounded-lg ${isSelected ? "bg-primary/20" : "bg-muted"}`}>
                    <option.icon className={`h-4 w-4 ${isSelected ? "text-primary" : "text-muted-foreground"}`} />
                  </div>
                  <span className="text-sm font-medium text-left">{option.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="flex gap-3">
        <Button variant="outline" className="flex-1" onClick={onBack}>
          Back
        </Button>
        <Button className="flex-1 gap-2" onClick={onNext}>
          Continue
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default OnboardingStep3;
